import React, { Component } from 'react';

import {
    getFreeShippingAudit, runFreeShippingAudit, dismissFreeShipping, undismissFreeShipping,
} from '../utils/mlApi';

// Publicaciones que ofrecen envío gratis SIN que MercadoLibre lo obligue: ahí ML no compensa
// nada y el flete lo paga Enigma entero.
//
// Vive en la pantalla de Integración ML —no en Configuraciones— porque es trabajo operativo
// sobre las publicaciones, del mismo tipo que "Sin sincronizar" y "Órdenes caídas". En
// Configuraciones va sólo la configuración de la cuenta (credenciales, modo, sucursal).

class FreeShippingAuditComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            auditoria: null,
            auditandoAhora: false,
            auditoriaError: '',
            desestimando: '',
        };
    }

    componentDidMount() {
        this.desmontado = false;
        this.cargarAuditoria();
    }

    componentWillUnmount() {
        this.desmontado = true;
    }

    cargarAuditoria = () => {
        getFreeShippingAudit()
            .then((data) => { if (!this.desmontado) this.setState({ auditoria: data }); })
            .catch(() => { /* mlApi ya cierra la sesión ante un 1002; el panel no puede romper la pantalla */ });
    }

    // Corre el barrido. NO toca stock ni publicaciones (dry-run), pero sí guarda el
    // resultado y manda el mail de aviso si encuentra algo.
    revisarPublicaciones = () => {
        this.setState({ auditandoAhora: true, auditoriaError: '' });
        runFreeShippingAudit()
            .then((d = {}) => {
                if (this.desmontado) return;
                // El backend puede responder OK sin haber revisado NADA (ML deshabilitado o
                // sin publicaciones alcanzables). Sin este chequeo, el panel pintaba el
                // cartel verde "ninguna regala el envío" justo cuando no pudo mirar.
                if (d.skipped || d.enabled === false) {
                    this.setState({ auditandoAhora: false, auditoriaError: d.reason || 'MercadoLibre está deshabilitado: no se revisó nada.' });
                    return;
                }
                this.setState({
                    auditandoAhora: false,
                    desestimando: '',
                    auditoria: {
                        count: d.freeShippingGiveaway || 0,
                        items: d.freeShippingGiveawayDetails || [],
                        checkedAt: new Date().toISOString(),
                        checkedInML: d.checkedInML,
                        listings: d.listings,
                        notAudited: d.freeShippingNotAudited || 0,
                        dismissed: d.freeShippingDismissed || [],
                        neverChecked: false,
                    },
                });
            })
            .catch((err) => {
                if (this.desmontado || (err && err.code === 1002)) return;
                // El barrido puede tardar minutos: si el request se cortó, el backend
                // probablemente terminó igual y ya persistió el resultado. Se re-lee antes
                // de declarar la falla, así no se pierde una revisión que sí ocurrió.
                this.setState({ auditandoAhora: false, auditoriaError: (err && err.message) || 'No se pudo revisar. Reintentá.' });
                this.cargarAuditoria();
            });
    }

    // Desestimar = "ya la miré, está bien así". Vuelve sola si BAJA el precio o cambia el
    // envío. Después de la acción se re-corre el barrido: es la única forma de que el resto
    // de la lista quede consistente (la foto guardada no trae precio ni título).
    desestimar = (externalItemId) => {
        const nota = window.prompt(
            `Desestimar ${externalItemId}.\n\n` +
            'Deja de contar para el badge y el mail. Va a reaparecer sola si baja de precio o si ' +
            'cambian las condiciones de envío.\n\n¿Por qué la desestimás? (opcional)'
        );
        if (nota === null) return;   // canceló
        this.setState({ desestimando: externalItemId });
        dismissFreeShipping(externalItemId, nota || '')
            .then(() => { if (!this.desmontado) this.revisarPublicaciones(); })
            .catch((err) => {
                if (this.desmontado || (err && err.code === 1002)) return;
                this.setState({ desestimando: '', auditoriaError: (err && err.message) || 'No se pudo desestimar.' });
            });
    }


    volverAVigilar = (externalItemId) => {
        this.setState({ desestimando: externalItemId });
        undismissFreeShipping(externalItemId)
            .then(() => { if (!this.desmontado) this.revisarPublicaciones(); })
            .catch((err) => {
                if (this.desmontado || (err && err.code === 1002)) return;
                this.setState({ desestimando: '', auditoriaError: (err && err.message) || 'No se pudo revertir.' });
            });
    }


    render() {
        const a = this.state.auditoria;
        const cantidad = a ? a.count : 0;
        // La foto guardada ahora trae precio y título: viven en `ml_free_shipping_finding`,
        // no en `configuration.value` (varchar(1000), que desbordaba a partir de 5
        // publicaciones). El fallback a `ids` queda como red para una foto ANTERIOR a esa
        // migración, que sólo tiene identificadores; sin él la tabla volvería a verse vacía
        // bajo un cartel que dice "4 publicación(es)".
        const items = (a && a.items && a.items.length)
            ? a.items
            : ((a && a.ids) || []).map((id) => ({ externalItemId: id, price: null, title: null }));
        const soloIds = !!(a && (!a.items || !a.items.length) && (a.ids || []).length);
        const desestimadas = (a && a.dismissed) || [];
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="m-0">
                        Detectadas
                        {cantidad > 0 ? <span className="badge badge-danger ml-2">{cantidad}</span> : null}
                    </h6>
                    <button type="button" className="btn btn-sm btn-outline-secondary"
                        onClick={this.revisarPublicaciones} disabled={this.state.auditandoAhora}>
                        {this.state.auditandoAhora ? 'Revisando…' : 'Revisar publicaciones'}
                    </button>
                </div>
                <small className="text-muted d-block mb-2">
                    Detecta publicaciones con envío gratis que MercadoLibre NO obliga: en esos casos ML
                    no compensa nada y el flete lo paga Enigma entero. <b>No toca el stock ni las
                    publicaciones</b>, pero guarda el resultado y avisa por mail si encuentra algo.
                    Puede tardar varios minutos (consulta las ~1.300 publicaciones): no cierres la pestaña.
                </small>
                {this.state.auditoriaError ? <div className="alert alert-danger py-2">{this.state.auditoriaError}</div> : null}
                {!a || a.neverChecked ? (
                    <div className="alert alert-secondary py-2 mb-0">Todavía no se revisó. Dale a "Revisar publicaciones".</div>
                ) : a.checkedInML === 0 ? (
                    <div className="alert alert-warning py-2 mb-0">
                        No se pudo revisar ninguna publicación (¿ML deshabilitado o sin conexión?).
                        <b> Esto NO quiere decir que esté todo bien.</b>
                    </div>
                ) : cantidad === 0 ? (
                    <div className="alert alert-success py-2 mb-0">
                        Ninguna publicación regala el envío
                        {a.checkedInML ? ` (revisadas ${a.checkedInML}${a.listings ? ` de ${a.listings}` : ''})` : ''}.
                        {' '}Última revisión: {new Date(a.checkedAt).toLocaleString('es-UY')}.
                        {a.notAudited > 0 ? <span className="text-warning"> {a.notAudited} sin datos de envío.</span> : null}
                    </div>
                ) : (
                    <div>
                        <div className="alert alert-danger py-2">
                            <b>{cantidad} publicación(es) regalan el envío.</b> ML no compensa el flete: en
                            productos de precio bajo la venta puede terminar en pérdida. Entrá a cada una en
                            MercadoLibre y desactivá el envío gratis.
                        </div>
                        {soloIds ? (
                            <small className="text-muted d-block mb-2">
                                Ésta es la última foto guardada: sólo tiene los identificadores.
                                Dale a <b>"Revisar publicaciones"</b> para ver precio y título.
                            </small>
                        ) : null}
                        <table className="table table-sm">
                            <thead><tr>
                                <th>Publicación</th>
                                <th style={{ textAlign: 'right' }}>Precio</th>
                                <th>Título</th>
                                <th style={{ width: '1%' }}></th>
                            </tr></thead>
                            <tbody>
                                {items.slice().sort((x, y) => (x.price || 0) - (y.price || 0)).map((r) => (
                                    <tr key={r.externalItemId}>
                                        <td>{r.externalItemId}</td>
                                        <td style={{ textAlign: 'right' }}>{r.price == null ? '—' : `$ ${r.price}`}</td>
                                        <td>
                                            {r.title || '—'}
                                            {r.reaparecio ? (
                                                <span className="badge badge-warning ml-2">volvió: {r.reaparecio}</span>
                                            ) : null}
                                        </td>
                                        <td>
                                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                                disabled={this.state.desestimando === r.externalItemId || this.state.auditandoAhora}
                                                onClick={() => this.desestimar(r.externalItemId)}>
                                                {this.state.desestimando === r.externalItemId ? '…' : 'Desestimar'}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <small className="text-muted">Última revisión: {new Date(a.checkedAt).toLocaleString('es-UY')}</small>
                    </div>
                )}
                {/* Va FUERA del ternario a propósito: si desestimaste todas, arriba queda el
                    cartel verde, y sin esto las publicaciones desaparecerían sin rastro y no
                    habría forma de volver a vigilarlas. */}
                {desestimadas.length > 0 ? (
                    <div className="mt-3">
                        <small className="text-muted d-block mb-1">
                            <b>{desestimadas.length} desestimada(s).</b> Revisadas y aceptadas: no cuentan
                            para el badge ni para el mail. Vuelven solas si baja el precio o cambian las
                            condiciones de envío.
                        </small>
                        <table className="table table-sm mb-0">
                            <tbody>
                                {desestimadas.map((r) => (
                                    <tr key={r.externalItemId} className="text-muted">
                                        <td>{r.externalItemId}</td>
                                        <td style={{ textAlign: 'right' }}>{r.price == null ? '—' : `$ ${r.price}`}</td>
                                        <td>{r.title || '—'}{r.nota ? <span className="ml-2 font-italic">“{r.nota}”</span> : null}</td>
                                        <td style={{ width: '1%' }}>
                                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                                disabled={this.state.desestimando === r.externalItemId || this.state.auditandoAhora}
                                                onClick={() => this.volverAVigilar(r.externalItemId)}>
                                                {this.state.desestimando === r.externalItemId ? '…' : 'Volver a vigilar'}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : null}
            </div>
        );
    }

}

export default FreeShippingAuditComponent;
